var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: -0.666667,
    y: -0.666667,
    width: 46.6667,
    height: 46.6667,
    rx: 10,
    transform: "matrix(1.31134e-07 -1 -1 -1.31134e-07 46.6667 46.6667)",
    fill: "white",
    stroke: "#E4E7EB",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2753 20.656C30.6384 21.019 30.6416 21.6108 30.2785 21.9739L24.9975 27.2549C24.997 27.2553 24.9966 27.2558 24.9962 27.2562C24.9957 27.2566 24.9953 27.2571 24.9949 27.2575L24.9935 27.2588C24.8351 27.4173 24.633 27.506 24.4254 27.5254C24.1585 27.5512 23.8827 27.4627 23.6788 27.2588L23.6757 27.2557L18.3884 21.9683C18.0253 21.6053 18.0279 21.0141 18.391 20.651C18.754 20.288 19.3452 20.2854 19.7083 20.6484L24.3351 25.2752L28.9575 20.6528C29.3205 20.2898 29.9123 20.2929 30.2753 20.656Z",
    fill: "#538FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBtnIcon);
export default __webpack_public_path__ + "static/media/DropdownBtnIcon.834b679d.svg";
export { ForwardRef as ReactComponent };